import React from 'react'
import { Flex, Box, Img } from '@chakra-ui/react'
import WebBeacon from 'components/common/webBeacon'
import urgent from '../../../assets/images/urgent-priority.svg'

const ErrorPageRetry = () => {
  const webBeaconSrc = process.env.REACT_APP_WEB_BEACON_IMAGE
  const title = 'Superaste el máximo de intentos'
  const subtitle = 'Ingresaste un dato erróneo y el código venció. Solicitá a tu empresa un nuevo link para validarte.'

  return (
    <Flex
    direction="column"
    align="center"
    justify="center"
    height="80vh" 
  >
    <WebBeacon src={webBeaconSrc} id='id-web-beacon' />
    <Img src={urgent} mb={5} />
    <Box textStyle='h3' textAlign="center" data-testid='loadingTitle' mb={5}>{title}</Box>
    <Box maxWidth='400px' textStyle='bodyLg' textAlign="center" data-testid='loadingDescription'>{subtitle}</Box>
  </Flex>
  )
}

export default ErrorPageRetry

